import { useDialogState } from '@user/utils/useDialogState'
import { ParentHeader as Container } from '@user/components/Opportunities/OpportunityCard/styling'
import Box from '@mui/material/Box'
import { NextActionDate } from '@user/components/EntityCards/atoms/NextActionDate/NextActionDate'
import { ExpectedClosingDate } from '@user/components/EntityCards/atoms/ExpectedClosingDate'
import { AttachmentsButton } from '@user/components/Leads/LeadCard/LeadAttachmentsDrawer/AttachmentIconButton'
import { OpportunityActions } from '@user/components/Opportunities/OpportunityActions/OpportunityActions'
import * as React from 'react'
import { OppStatus } from '@user/components/Opportunities/OpportunityCard/typings'
import { ENTITY_TYPES, IUser, SOLD_SERVICE_STATUS } from '@sales-center/common'
import { EntityAttachmentsDrawer } from '@user/features/EntityDetails/components/EntityAttachmentsDrawer'
import Hidden from '@mui/material/Hidden'
import Stack from '@mui/material/Stack'

interface Props {
  attachmentCount: number
  closedDate: Date | null
  closeWinDisabled: boolean
  closeWinErrors: string[]
  detailPage?: boolean
  expectedClosingDate: Date | null
  locationId: string
  nextActionDate: Date | null
  opportunityId: number
  salesFunnelId: number
  salesFunnelStageId: number
  oppStatus: OppStatus
  assignee: IUser | null
  branchId: string
  branch: string
  salesTeamId: number
  canUpdate: boolean
  canDelete: boolean
  soldServiceStatus: SOLD_SERVICE_STATUS
}

export function OpportunityParentHeader(props: Props) {
  const { detailPage, opportunityId, canUpdate } = props
  const [attachmentsDrawerOpen, showAttachmentsDrawer, hideAttachmentsDrawer] =
    useDialogState()

  const attachmentsState = {
    onOpenAttachments: showAttachmentsDrawer,
    onCloseAttachments: hideAttachmentsDrawer,
    attachmentsOpen: attachmentsDrawerOpen,
  }

  return (
    <Container>
      <Hidden lgDown={detailPage}>
        <Stack mr={2.4} direction="row" spacing={2}>
          <NextActionDate
            id={props.opportunityId}
            nextActionDate={props.nextActionDate}
            disabled={!props.canUpdate}
          />
        </Stack>
        <Box mr={2}>
          <ExpectedClosingDate
            id={props.opportunityId}
            disabled={!props.canUpdate}
            expectedClosingDate={props.expectedClosingDate}
            required
          />
        </Box>

        {detailPage && <AttachmentsButton {...attachmentsState} />}
      </Hidden>

      <Box display="flex" flex-direction="row" ml="auto">
        <Box mr={-1.2} alignItems="center" display="flex">
          <OpportunityActions
            {...props}
            showStatusSelect={true}
            assigneeId={props.assignee?.id || null}
            closedDate={props.closedDate || null}
          />
        </Box>
      </Box>

      <EntityAttachmentsDrawer
        entityType={ENTITY_TYPES.Opportunity}
        entityId={opportunityId}
        canUpdate={canUpdate}
        {...attachmentsState}
      />
    </Container>
  )
}
